/**
 * @file loginView.jsx
 * @author Fernando Ruano
 * @description StepTwo View Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

// Assets
import baxterRenal from '@nephro/assets/baxterRenalWhite.png';
import baxterRenalResponsive from '@nephro/assets/baxterRenalVertical.png';

// Styles
import styles from './styles.module.css';

function LoginTemplateView({
  showTitle,
  showContent,
  title,
  textContent,
  loading,
  children
}) {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const onBack = () => history.goBack();

  return (
    <div className={styles.templateViewStyle}>
      <div className="flex flex-auto justify-center items-center md:hidden">
        <img src={baxterRenal} className="w-3/4 md:w-1/2" />
      </div>
      <div className="flex flex-auto justify-center items-center hidden md:flex">
        <img src={baxterRenalResponsive} className="w-3/4 md:w-1/2" />
      </div>
      <div className={styles.cardTemplate}>
        <Spin spinning={loading} size="large">
          <div className="px-7 md:px-7 lg:px-10">
            <ArrowLeftOutlined style={{ fontSize: 24 }} onClick={onBack} />
            {showTitle && (
              <h2 className="text-xl md:text-2xl font-bold text-secondary mt-8">
                {translate(title)}
              </h2>
            )}
            {showContent && (
              <h2 className="text-base md:text-base text-secondary mt-5 mb-7">
                {translate(textContent)}
              </h2>
            )}
            {React.Children.only(children)}
          </div>
        </Spin>
      </div>
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
LoginTemplateView.propTypes = {
  showTitle: PropTypes.bool,
  showContent: PropTypes.bool,
  title: PropTypes.string,
  textContent: PropTypes.string,
  customBack: PropTypes.any,
  loading: PropTypes.bool,
  children: PropTypes.element.isRequired
};

/**
 * Default properties.
 */
LoginTemplateView.defaultProps = {
  showTitle: true,
  showContent: true,
  loading: false,
  customBack: null
};
export default LoginTemplateView;
